<template>
  <div class="pd-medium">
    <h2 class="h4 mn-b-medium">{{ $t('subscriptions.title') }}</h2>

    <div v-if="loading" class="t-center pd-big">
      <Loader />
    </div>

    <div v-else-if="subscriptions.length === 0" class="t-center pd-big">
      <p class="t-grey">{{ $t('subscriptions.noSubscriptions') }}</p>
    </div>

    <div v-else class="d-flex flex-column gap-small">
      <CardSubscription
        v-for="sub in subscriptions"
        :key="sub._id"
        :subscription="sub"
        @cancel="handleCancel"
        @pause="handlePause"
        @resume="handleResume"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import Loader from '@martyrs/src/design-system/components/Loader/Loader.vue';
import CardSubscription from '../blocks/CardSubscription.vue';

const store = inject('store');
const subscriptions = ref([]);
const loading = ref(true);

onMounted(async () => {
  try {
    subscriptions.value = await store.subscriptions.actions.listSubscriptions();
  } finally {
    loading.value = false;
  }
});

async function handleCancel(id) {
  await store.subscriptions.actions.cancel(id, { immediate: false });
  subscriptions.value = await store.subscriptions.actions.listSubscriptions();
}

async function handlePause(id) {
  await store.subscriptions.actions.pause(id);
  subscriptions.value = await store.subscriptions.actions.listSubscriptions();
}

async function handleResume(id) {
  await store.subscriptions.actions.resume(id);
  subscriptions.value = await store.subscriptions.actions.listSubscriptions();
}
</script>
